module.exports = __webpack_public_path__ + "img/title.0051db15.png";